module.exports = __webpack_public_path__ + "img/logo-smtt@3x.b993ab44.png";